import { render, staticRenderFns } from "./OrgDemands.vue?vue&type=template&id=c417403a&scoped=true&"
import script from "./OrgDemands.vue?vue&type=script&lang=js&"
export * from "./OrgDemands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c417403a",
  null
  
)

export default component.exports